import axios from 'axios';

const API_URL = 'https://comoticket-production.up.railway.app/api';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('comoticket_token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('comoticket_token');
      localStorage.removeItem('comoticket_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;